import { GetServerSideProps } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { AbonnementPage } from '~/atomic/page/bookSubscriptions/AbonnementPage';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { TransactionLoader } from '~/feature/book/paymentResult/TransactionLoader';
import { createStore, RootState } from '~/store';

const Abonnement = () => {
  const title = 'Абонемент';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.bookSubscriptions.isPublic}
      seo={{
        title,
        canonical: pagesConfigStore.bookSubscriptions.url,
      }}
      content={(
        <>
          <AbonnementPage />
          <TransactionLoader />
        </>
      )}
    />
  );
};

Abonnement.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (context) => {
  const { dispatch, store } = await createStore();
  await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};
export default Abonnement;
